import { cn } from '../helpers/utils.js'
import type { FC } from 'react'

interface LoadingProps {
  className?: string
}

/**
 * LoadingDots - 加载动画点
 *
 * @description 三个点的加载动画组件，提供优雅的等待状态视觉反馈
 */
const LoadingDots: FC<LoadingProps> = props => {
  const { className } = props
  return (
    <>
      <style>{`span.root {
  min-height: 19px;
  align-items: center;
  text-align: center;
  line-height: 7;
  display: inline-flex !important;
}

span.root .dot {
  height: 8px;
  width: 8px;
  border-radius: 100%;
  background-color: currentColor;
  animation-name: blink;
  animation-duration: 1.6s;
  animation-iteration-count: infinite;
  animation-fill-mode: both;
  margin: 0 2px;
}

.root .dot:nth-of-type(2) {
  animation-delay: 0.2s;
}

.root .dot::nth-of-type(3) {
  animation-delay: 0.4s;
}

@keyframes blink {
  0% {
    opacity: 0.2;
  }
  20% {
    opacity: 1;
  }
  100% {
    opacity: 0.2;
  }
}

    `}</style>
      <span className={cn('root', className)}>
        <span className="dot" key={`dot_1`} />
        <span className="dot" key={`dot_2`} />
        <span className="dot" key={`dot_3`} />
      </span>
    </>
  )
}

export default LoadingDots
